import { createContext, useContext } from 'react'

// Context that DemoProvider populates
export const DemoModeContext = createContext({
  isDemoMode: false,
  demoStore: null,
  enterDemoMode: () => {},
  exitDemoMode: () => {}
})

export const useDemoMode = () => useContext(DemoModeContext)

// Session-storage helpers
const DEMO_KEY = 'prosperia_demo_mode'

export function getDemoFlag() {
  try {
    return sessionStorage.getItem(DEMO_KEY) === 'true'
  } catch {
    return false
  }
}

export function setDemoFlag(value) {
  try {
    if (value) {
      sessionStorage.setItem(DEMO_KEY, 'true')
    } else {
      sessionStorage.removeItem(DEMO_KEY)
    }
  } catch {
    // sessionStorage unavailable (e.g. private browsing edge cases)
  }
}
